import { Routes, Route } from 'react-router-dom';
import { AppShell } from '@/components/AppShell';
import { Home } from '@/pages/Home';
import { Clients } from '@/pages/Clients';
import { NewClient } from '@/pages/NewClient';
import { ClientEdit } from '@/pages/ClientEdit';
import { Engagements } from '@/pages/Engagements';
import { NewEngagement } from '@/pages/NewEngagement';
import { EngagementEdit } from '@/pages/EngagementEdit';
import { EngagementAdditional, ClientAdditional } from '@/pages/AdditionalDetails';
import { Pending } from '@/pages/Pending';
import { Completed } from '@/pages/Completed';
import { DownloadPending } from '@/pages/DownloadPending';
import { Users } from '@/pages/Users';
import { RequestForms } from '@/pages/RequestForms';

export default function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<Home />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/new" element={<NewClient />} />
        <Route path="/clients/:clientId/:subId" element={<ClientEdit />} />
        <Route path="/clients/:clientId/:subId/additional" element={<ClientAdditional />} />
        <Route path="/engagements" element={<Engagements />} />
        <Route path="/engagements/new" element={<NewEngagement />} />
        <Route path="/engagements/:id" element={<EngagementEdit />} />
        <Route path="/engagements/:id/additional" element={<EngagementAdditional />} />
        <Route path="/pending" element={<Pending />} />
        <Route path="/pending/download" element={<DownloadPending />} />
        <Route path="/completed" element={<Completed />} />
        <Route path="/forms" element={<RequestForms />} />
        <Route path="/users" element={<Users />} />
        <Route path="*" element={<div className="p-6">Page not found.</div>} />
      </Route>
    </Routes>
  );
}
